import {
  Box,
  Container,
  Divider,
  Paper,
  Typography
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import React from 'react';

const Tema13 = () => {
  return (
    <Container>
      <Paper
        variant="outlined"
        className="center-box"
        sx={{
          textAlign: 'center',
          px: 4,
          pt: 2,
          pb: 3,
          m: 5
        }}
      >
        <Divider>
          <h3>Assessment ESG</h3>
        </Divider>
        <Grid
          height={400}
          width={'100%'}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <a
            href="https://esg-assessment.falconi.com/"
            target="_blank"
            rel="noreferrer"
          >
            Termômetro da Gestão em ESG da sua empresa.
          </a>
        </Grid>
      </Paper>
    </Container>
  );
};

export default Tema13;
